/**
 * Base error class for template storage operations
 */
export class TemplateStorageError extends Error {
  constructor(message: string, public cause?: Error) {
    super(message);
    this.name = 'TemplateStorageError';
    
    // Maintain proper stack trace for where our error was thrown
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, TemplateStorageError);
    }
  }
}

/**
 * Error thrown when template validation fails
 */
export class TemplateValidationError extends TemplateStorageError {
  constructor(message: string, public validationDetails: any) {
    super(message);
    this.name = 'TemplateValidationError';
    
    // Maintain proper stack trace
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, TemplateValidationError);
    }
  }
}

/**
 * Error thrown when template access is denied
 */
export class TemplateAccessError extends TemplateStorageError {
  constructor(message: string, public templateId: string) {
    super(message);
    this.name = 'TemplateAccessError';
    
    // Maintain proper stack trace
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, TemplateAccessError);
    }
  }
}

/**
 * Error thrown when a template is not found
 */
export class TemplateNotFoundError extends TemplateStorageError {
  constructor(message: string, public templateId?: string, public plannerId?: string) {
    super(message);
    this.name = 'TemplateNotFoundError';
    
    // Maintain proper stack trace
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, TemplateNotFoundError);
    }
  }
}

/**
 * Error thrown when there's an issue with the storage service
 */
export class StorageServiceError extends TemplateStorageError {
  constructor(message: string, public bucket?: string, public path?: string, cause?: Error) {
    super(message, cause);
    this.name = 'StorageServiceError';
    
    // Maintain proper stack trace
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, StorageServiceError);
    }
  }
}